import { render } from "./TabHeader.vue?vue&type=template&id=2ed550b5&scoped=true"
import script from "./TabHeader.vue?vue&type=script&lang=js"
export * from "./TabHeader.vue?vue&type=script&lang=js"

import "./TabHeader.vue?vue&type=style&index=0&id=2ed550b5&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed550b5"]])

export default __exports__